export enum DepotsRoutePathsEnum {
  DEPOT = 'depots/:depotId',
  DEPOTS = 'depots',
}
